// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__VXDBI","toggleWrap":"styles_toggleWrap__32WTp","content":"styles_content__1kW_j","selectAreaCode":"styles_selectAreaCode__2SdqJ"};